import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import moment, { Moment } from 'moment';
import { getDatepickerLocale } from '@/helpers/LocaleHelper';
import StepHeader from '@/modules/Logistics/components/StepHeader.vue';
import OrderSelector from '@/modules/Logistics/components/OrderSelector.vue';
import InternalOrderSelector from '@/modules/Logistics/components/InternalOrderSelector.vue';
import DeliveryList from '@/modules/Logistics/components/DeliveryList.vue';
import InformationModal from '@/components/global/popup/InformationModal.vue';
import type {
    DeliveryListFormData,
    DeliveryListPrintData,
    MontageTeamDropdownOption,
    SpreadsheetData,
    VehicleDropdownOption,
} from '@/modules/Logistics/interfaces/LogisticsInterfaces';
import type {
    DeliveryClientOption,
    DeliveryOrder,
    DeliveryRegionOption,
} from '@/modules/Logistics/interfaces/DeliveryOrderInterfaces';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeliveryListGenerator',
  props: {
    currentStep: null,
    orders: null,
    selectedOrders: null,
    selectedOrderIds: null,
    selectedInternalOrderIds: null,
    lockedInternalOrderIds: null,
    selectedDates: null,
    clients: null,
    selectedClientId: null,
    clientSearchLoading: { type: Boolean },
    deliveryRegions: null,
    selectedDeliveryRegionId: null,
    ordersLoading: { type: Boolean },
    printData: null,
    montageTeams: null,
    vehicles: null,
    totalPieces: null
  },
  emits: ["dates-change", "client-search", "client-change", "delivery-region-change", "order-selection-change", "internal-order-selection-change", "spreadsheet-change", "form-field-update"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'dates-change', dates: Moment[]): void;
    (e: 'client-search', searchQuery: string): void;
    (e: 'client-change', clientId: string | null): void;
    (e: 'delivery-region-change', deliveryRegionId: string | null): void;
    (e: 'order-selection-change', orderIds: string[]): void;
    (e: 'internal-order-selection-change', internalOrderIds: number[]): void;
    (e: 'spreadsheet-change', data: SpreadsheetData | null): void;
    (
        e: 'form-field-update',
        field: keyof DeliveryListFormData,
        value: DeliveryListFormData[keyof DeliveryListFormData],
    ): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    currentStep: number;
    orders: DeliveryOrder[];
    selectedOrders: DeliveryOrder[];
    selectedOrderIds: string[];
    selectedInternalOrderIds: number[];
    lockedInternalOrderIds: number[];
    selectedDates: Moment[];
    clients: DeliveryClientOption[];
    selectedClientId?: string;
    clientSearchLoading: boolean;
    deliveryRegions: DeliveryRegionOption[];
    selectedDeliveryRegionId?: string;
    ordersLoading: boolean;
    printData: DeliveryListPrintData;
    montageTeams: MontageTeamDropdownOption[];
    vehicles: VehicleDropdownOption[];
    totalPieces: number;
};



const isLoadingListModalVisible = ref(false);

const locale = computed(() => getDatepickerLocale());

const deliveryDateMoment = computed(() => {
    const deliveryDate = props.printData.formData?.deliveryDate;
    if (!deliveryDate) return null;

    const parsedDate = moment(deliveryDate, ['YYYY-MM-DD', 'DD.MM.YYYY', moment.ISO_8601]);
    return parsedDate.isValid() ? parsedDate : null;
});



const currentStepSubtitle = computed(() => {
    if (props.currentStep === 0) {
        return props.selectedDates.length ? `${props.orders.length} orders` : 'Choose a delivery date';
    }
    if (props.currentStep === 1) {
        return `${props.selectedOrderIds.length} selected orders`;
    }
    return `${props.selectedInternalOrderIds.length} selected internal orders`;
});

function handleFormFieldUpdate(
    field: keyof DeliveryListFormData,
    value: DeliveryListFormData[keyof DeliveryListFormData],
) {
    emit('form-field-update', field, value);
}

function handleDeliveryDateChange(value: Moment | null) {
    emit('form-field-update', 'deliveryDate', value?.isValid() ? value.format('DD.MM.YYYY') : '');
}

expose({
    currentStepSubtitle,
});

return { __sfc: true,props, isLoadingListModalVisible, locale, deliveryDateMoment, emit, currentStepSubtitle, handleFormFieldUpdate, handleDeliveryDateChange, StepHeader, OrderSelector, InternalOrderSelector, DeliveryList, InformationModal }
}

})